export const GET_TEXTOS = "GET_TEXTOS";
export const GET_TEXTOS_SUCCESS = "GET_TEXTOS_SUCCESS";
export const GET_TEXTOS_FAIL = "GET_TEXTOS_FAIL";

export const SET_PASO_VALIDATURNO = "SET_PASO_VALIDATURNO";
export const SET_POSICION_VALIDATURNO = "SET_POSICION_VALIDATURNO";
export const SET_INFORMACION_VALIDATURNO = "SET_INFORMATION_VALIDATURNO";
export const SET_ORDEN_VALIDATURNO = "SET_ORDEN_VALIDATURNO";

export const GET_TURNOS = "GET_TURNOS";
export const GET_TURNOS_SUCCESS = "GET_TURNOS_SUCCESS";
export const GET_TURNOS_FAIL = "GET_TURNOS_FAIL";

export const MEDICO_POR_MATRICULA = "MEDICO_POR_MATRICULA";
export const MEDICO_POR_MATRICULA_SUCCESS = "MEDICO_POR_MATRICULA_SUCCESS";
export const MEDICO_POR_MATRICULA_FAIL = "MEDICO_POR_MATRICULA_FAIL";

export const SELECCIONA_MEDICO_LABO = "SELECCIONA_MEDICO_LABO";
export const SELECCIONA_MEDICO_LABO_SUCCESS = "SELECCIONA_MEDICO_LABO_SUCCESS";
export const SELECCIONA_MEDICO_LABO_FAIL = "SELECCIONA_MEDICO_LABO_FAIL";

export const SELECCIONA_MEDICO_TURNO = "SELECCIONA_MEDICO_TURNO";
export const SELECCIONA_MEDICO_TURNO_SUCCESS =
  "SELECCIONA_MEDICO_TURNO_SUCCESS";
export const SELECCIONA_MEDICO_TURNO_FAIL = "SELECCIONA_MEDICO_TURNO_FAIL";

export const ESTADO_ORDEN = "ESTADO_ORDEN";
export const ESTADO_ORDEN_SUCCESS = "ESTADO_ORDEN_SUCCESS";
export const ESTADO_ORDEN_FAIL = "ESTADO_ORDEN_FAIL";
export const SET_ORDEN = "SET_ORDEN";

export const SET_CIRCUITO = "SET_CIRCUITO";
export const SET_PASO = "SET_PASO";
export const SET_PASO_ANTERIOR = "SET_PASO_ANTERIOR";
export const SET_RUTA = "SET_RUTA";
export const SET_TURNOS_SELECCIONADOS = "SET_TURNOS_SELECCIONADOS";

export const SET_TURNOS_RECEPCIONADOS = "SET_TURNOS_RECEPCIONADOS";

export const SET_UBICACION = "SET_UBICACION";

export const PRESENTE = "PRESENTE";
export const PRESENTE_SUCCESS = "PRESENTE_SUCCESS";
export const PRESENTE_FAIL = "PRESENTE_FAIL";
export const PRESENTE_RESET = "PRESENTE_RESET";

export const SET_TURNOS_RECEPCIONADOS_ALL = "SET_TURNOS_RECEPCIONADOS_ALL";

export const GET_ATENCION_SIN_TURNO = "GET_ATENCION_SIN_TURNO";
export const GET_ATENCION_SIN_TURNO_SUCCESS = "GET_ATENCION_SIN_TURNO_SUCCESS";
export const GET_ATENCION_SIN_TURNO_FAIL = "GET_ATENCION_SIN_TURNO_FAIL";

export const GET_CENTROS = "GET_CENTROS";
export const GET_CENTROS_SUCCESS = "GET_CENTROS_SUCCESS";
export const GET_CENTROS_FAIL = "GET_CENTROS_FAIL";

export const FILAVIRTUAL = "FILAVIRTUAL";
export const FILAVIRTUAL_SUCCESS = "FILAVIRTUAL_SUCCESS";
export const FILAVIRTUAL_FAIL = "FILAVIRTUAL_FAIL";
export const FILAVIRTUAL_RESET = "FILAVIRTUAL_RESET";

export const DEMORA = "DEMORA";
export const DEMORA_SUCCESS = "DEMORA_SUCCESS";
export const DEMORA_FAIL = "DEMORA_FAIL";
export const DEMORA_RESET = "DEMORA_RESET";

export const SET_IDTIPO_PUNTOCONTROL = "SET_IDTIPO_PUNTOCONTROL";

export const GET_TXT_PUNTOCONTROL = "GET_TXT_PUNTOCONTROL";

export const SET_TURNOS_SELECCIONADOS_LABO = "SET_TURNOS_SELECCIONADOS_LABO";
export const SET_ACTUAL_SELECCIONADOS = "SET_ACTUAL_SELECCIONADOS";

export const MERCADO_PAGO = "MERCADO_PAGO";
export const MERCADO_PAGO_SUCCESS = "MERCADO_PAGO_SUCCESS";
export const MERCADO_PAGO_FAIL = "MERCADO_PAGO_FAIL";

export const SET_NRO_AFILIADO = "SET_NRO_AFILIADO";

export const SET_AVISO_AUTOCHECK = "SET_AVISO_AUTOCHECK";
